import { render, staticRenderFns } from "./server.vue?vue&type=template&id=4a7a4dd0&scoped=true&"
import script from "./server.vue?vue&type=script&lang=js&"
export * from "./server.vue?vue&type=script&lang=js&"
import style0 from "./server.vue?vue&type=style&index=0&id=4a7a4dd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7a4dd0",
  null
  
)

export default component.exports